export default __webpack_public_path__ + "static/2630a3e3eab21c607e21576571b95b9d.svg";